import React from "react";
import { useFormikContext } from "formik";
import FormikInput from "../../Formik/FormikInput";
import FormikSelect from "../../Formik/FormikSelect";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";

const StyledLabel = styled.label`
  color: #535559;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
`;
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: #ff5837;
  }
`;

const PartnerAssignment = () => {
  const { setFieldValue, values } = useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];

  return (
    <div>
      <FormContainer className="row g-3 px-2">
        <div>
          <input type="checkbox" className="checkbox_input" />
          <span className="ms-2">{t["Geolocate"]}</span>
        </div>
        <div className="col-md-4">
          <StyledLabel
            htmlFor="inputPassword4"
            className="form-label"
            defaultValue=""
          >
            {t["On"]}
          </StyledLabel>
          <FormikSelect
            name="on"
        
          />
        </div>
        <div className="col-md-4">
          <StyledLabel
            htmlFor="inputPassword4"
            className="form-label"
            defaultValue=""
          >
            {t["Late"]}
          </StyledLabel>
          <FormikInput type="number" name="late" />
        </div>
        <div className="col-md-4">
          <StyledLabel
            htmlFor="industry"
            className="form-label"
            defaultValue=""
          >
            {t["Long"]}
          </StyledLabel>
          <FormikSelect
            name="long"
            
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default PartnerAssignment;
